module.exports = __webpack_public_path__ + "static/media/failed.1f98c51a.png";